import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput, View } from 'react-native';

import styles from './feedback-form.style';
import { useColors } from '../../../hooks';
import ThemedText2 from '../../themed-text-2';

interface FeedbackFormProps {
  nlsKeys: {
    instructions: string;
    enterText: string;
  };
  value: string;
  onChangeText: (value: string) => void;
}

const MAX_CHARS = 450;

export default function FeedbackForm({
  nlsKeys,
  value,
  onChangeText,
}: FeedbackFormProps) {
  const { t } = useTranslation();
  const colors = useColors();

  return (
    <>
      <ThemedText2 style={styles.instructions}>
        {t(nlsKeys.instructions)}
      </ThemedText2>
      <View
        style={[
          styles.textAreaContainer,
          {
            backgroundColor: colors.background,
            borderColor: colors.borderColor,
          },
        ]}
      >
        <TextInput
          style={[
            styles.textArea,
            {
              borderColor: colors.transparent,
              backgroundColor: colors.background,
            },
          ]}
          multiline
          value={value}
          onChangeText={onChangeText}
          maxLength={MAX_CHARS}
          placeholder={t(nlsKeys.enterText) as string}
        />
        <ThemedText2
          style={[styles.charactersLeft, { color: colors.lightSilverGray }]}
        >
          {t('mobile.feedback.charactersLeft') +
            ' ' +
            (MAX_CHARS - value.length)}
        </ThemedText2>
      </View>
    </>
  );
}
